import type { ReactNode } from 'react';
import { useContext } from 'react';

import { Box } from '#/components/Box/Box';
import { Body } from '#/components/Text/Body';
import { TabContext } from '#/containers/TabContext';

import {
  CheckmarkContainer,
  LargeRadioButtonContainer,
  LargeRadioButtonInput,
} from './LargeRadioButton.styled';

type Props = {
  qaId?: string;
  'data-checked': boolean;
  id?: string;
  name?: string;
  value: string | boolean | number;
  label: ReactNode;
  checked: boolean;
  alignTop?: boolean;
  hideRadioButtons?: boolean;
  disabled?: boolean;
  required?: boolean;
  onChange?: (newValue: string | number | boolean) => void;
  onClick?: () => void;
};

export function LargeRadioButton({
  id,
  name,
  value,
  label,
  checked,
  alignTop,
  hideRadioButtons,
  disabled,
  required,
  qaId,
  'data-checked': dataChecked,
  onChange,
  onClick,
}: Props) {
  const isTabbing = useContext(TabContext);

  return (
    <LargeRadioButtonContainer
      $checked={checked}
      $disabled={disabled}
      $alignTop={alignTop}
    >
      <Box top={0} left={0} position="absolute" width={1} height="100%">
        <LargeRadioButtonInput
          type="radio"
          name={name}
          id={id}
          checked={checked}
          required={required}
          value={typeof value === 'string' ? value : value.toString()}
          onChange={(e) => {
            e.stopPropagation();

            if (onChange) {
              onChange(value);
            }
          }}
          $isTabbing={isTabbing}
          $hideRadioButtons={hideRadioButtons}
          disabled={disabled}
          onClick={onClick}
          data-qa-id={qaId}
          data-checked={dataChecked ? true : undefined}
        />
      </Box>
      {!hideRadioButtons && (
        <CheckmarkContainer $checked={checked} $alignTop={alignTop}>
          <span />
        </CheckmarkContainer>
      )}
      <label htmlFor={id} style={{ marginLeft: 14 }}>
        <Box component={Body} lineHeight={1.375} pointerEvents="none">
          {label}
        </Box>
      </label>
    </LargeRadioButtonContainer>
  );
}
